// extracted by mini-css-extract-plugin
module.exports = {"btn":"Tooltip_btn__KrM_x","btn__icon":"Tooltip_btn__icon__9HL_B","btn__text":"Tooltip_btn__text__MWYGI"};